export default "__VITE_ASSET__ClVVjCVQ__"